import {
    BANKDISTRICTLIST_SUCCESS,
    BANKDISTRICTLIST_FAILED,
    RESET_BANKDISTRICTLIST,
    LOADING_BANKDISTRICTLIST,
    BANKDISTRICTLIST_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BANKDISTRICTLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BANKDISTRICTLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BANKDISTRICTLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case BANKDISTRICTLIST_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BANKDISTRICTLIST:
            return (state = initialState);
        default:
            return state;
    }
};
